import { Link, useNavigate } from "react-router-dom";
import { useMemo } from "react";

export default function SoloResults() {
  const nav = useNavigate();
  const data = useMemo(() => {
    const raw = sessionStorage.getItem("themix_solo_results");
    return raw ? JSON.parse(raw) as { score: number; total: number; accuracy: number; avgMs: number | null } : null;
  }, []);
  if (!data) {
    return (
      <p>
        Pas de résultats. <Link to="/solo">Rejouer</Link>
      </p>
    );
  }
  return (
    <div className="pt-8 grid gap-6 text-center">
      <h1 className="font-display text-5xl">Bravo</h1>
      <p className="text-3xl">
        {data.score} / {data.total}
      </p>
      <p className="opacity-80">Réussite {(data.accuracy * 100).toFixed(0)} %</p>
      {data.avgMs != null && <p>Temps moyen {(data.avgMs / 1000).toFixed(1)} s</p>}
      <button type="button" className="rounded-3xl bg-gold text-ink py-4 font-bold" onClick={() => nav("/solo")}>
        Rejouer
      </button>
    </div>
  );
}
